import React from 'react';
import Badge from './Badge';

const ActivityBadge = ({ active }) => {
  return active ? <Badge text="Active" color="green" /> : <Badge text="Inactive" color="red" />;
};

export default ActivityBadge;
